//#region src/locales/vi/tamagotchi/settings.yaml
var data = {
	"allow-visible-on-all-workspaces": {
		"title": "Hiển thị ở mọi nơi",
		"description": "Cho phép cửa sổ hiển thị trên tất cả workspaces, chỉ áp dụng cho macOS."
	},
	"spotlight": { "errors": {
		"unknown": "Lỗi không xác định",
		"prefix": "Đã xảy ra lỗi: {message}",
		"shortcutRegistrationFailed": "Đã xảy ra lỗi: không đăng ký được phím tắt Spotlight."
	} },
	"pages": {
		"modules": { "mcp-server": {
			"description": "Kết nối và quản lý máy chủ MCP và các công cụ",
			"title": "Máy chủ MCP"
		} },
		"system": {
			"sections": { "section": { "window-shortcuts": { "title": "Phím tắt Windows" } } },
			"window-shortcuts": {
				"description": "Chỉnh sửa các phím tắt cho Windows.",
				"title": "Phím tắt Windows",
				"empty": "Chưa đặt",
				"spotlight": {
					"title": "Phím tắt Spotlight",
					"description": "Bấm vào phím tắt, rồi nhấn phím tắt mới. Nhấn Esc để hủy."
				},
				"actions": {
					"recording": "Nhấn phím",
					"reset": "Đặt lại"
				},
				"errors": {
					"load": "Không tải được phím tắt",
					"conflict": "Phím tắt này đã được sử dụng.",
					"failed": "Không cập nhật được phím tắt",
					"requiresModifier": "Dùng ít nhất một trong các phím Cmd, Ctrl, Alt hoặc Super."
				},
				"toggle-move": { "label": "Bật/Tắt Di chuyển" },
				"toggle-resize": { "label": "Bật/Tắt Thay đổi kích thước" },
				"toggle-ignore-mouse-event": { "label": "Bật/Tắt Bỏ qua sự kiện chuột" },
				"press-keys": "Nhấn phím..."
			},
			"developer": { "sections": { "section": { "use-window-mouse": {
				"title": "Công cụ useWindowMouse",
				"description": "Kiểm tra vị trí con trỏ chuột trong cửa sổ Electron"
			} } } }
		}
	},
	"devtools": {
		"title": "Nhà phát triển",
		"pages": {
			"context-flow": { "title": "Luồng ngữ cảnh" },
			"editor": {
				"title": "Trình chỉnh sửa AIRI",
				"description": "Mở cửa sổ Trình chỉnh sửa AIRI độc lập",
				"button": "Mở trình chỉnh sửa"
			},
			"lag-visualizer": { "title": "Trình trực quan hóa độ trễ" },
			"performance-visualizer": {
				"title": "Trình trực quan hóa hiệu năng",
				"description": "Bật/Tắt lớp phủ hiển thị FPS/tác vụ dài/bộ nhớ",
				"controls": {
					"enable-all": {
						"label": "Bật tất cả các chỉ số khả dụng",
						"description": "Bật từng chỉ số mà trình duyệt này hỗ trợ."
					},
					"start-recording": "Bắt đầu ghi",
					"stop-recording": "Dừng ghi ({seconds} giây)",
					"export-last-recording": "Xuất bản ghi gần nhất"
				},
				"metrics": {
					"frame-duration": {
						"label": "Thời gian khung hình (ms)",
						"description": "Thời gian giữa các khung hình hoạt ảnh trong 10 giây qua."
					},
					"long-task": {
						"label": "Tác vụ dài",
						"description": "Các tác vụ luồng chính (main-thread) mất ít nhất 50 ms.",
						"unsupported": "Trình duyệt này không hiển thị thời gian tác vụ dài."
					},
					"memory": {
						"description": "Dung lượng bộ nhớ JavaScript heap từ API performance.memory của Chromium.",
						"unsupported": "Trình duyệt này không hiển thị dung lượng bộ nhớ JavaScript heap."
					}
				},
				"recording": {
					"title": "Bản ghi gần nhất",
					"duration": "Thời lượng {duration} ms",
					"limit": "Bản ghi sẽ dừng sau 60 giây."
				},
				"overlay": {
					"title": "Hiệu năng",
					"move": "Di chuyển lớp phủ hiệu năng",
					"reset-position": "Đặt lại vị trí lớp phủ",
					"record": "Ghi",
					"stop": "Dừng",
					"export": "Xuất bản ghi gần nhất",
					"average": "trung bình"
				}
			},
			"markdown-stress": {
				"title": "Kiểm thử áp lực Markdown",
				"description": "Kiểm tra khả năng xử lý và hiển thị Markdown với dữ liệu hội thoại lớn"
			},
			"io-tracer": { "title": "Trình theo dõi I/O (IO Tracer)" },
			"widgets-calling": { "title": "Gọi Widget" }
		}
	},
	"screen-capture": { "permissions-prompt": {
		"title": "Chụp ảnh màn hình",
		"description": "Để chụp màn hình hoặc cửa sổ, bạn cần cấp quyền ghi âm hệ thống và ghi màn hình.",
		"open-preferences": "Mở Tùy chọn hệ thống",
		"dismiss": "Bỏ qua",
		"instructions": {
			"step-1": "Mở \"Tùy chọn hệ thống\", chọn \"Quyền riêng tư & Bảo mật\" từ thanh bên.",
			"step-2": "Trong phần \"Ghi màn hình & Âm thanh hệ thống\" và \"Chỉ ghi âm thanh hệ thống\", hãy bật công tắc cho AIRI.",
			"step-2-note": "Nếu không thấy AIRI trong danh sách, vui lòng thêm thủ công bằng cách nhấn nút \"+\" và chọn AIRI từ thư mục Ứng dụng (Applications)."
		}
	} }
};
//#endregion
export { data as default };
